import { FormEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Button,
    Dialog,
    Alert,
} from "@mui/material";
import ModalCard, { ModalTitle } from "../ModalCard";
import Progress from "../../progress/Progress";
import { defaultLocalRequest } from "../../../models/requests/local/localEditRequest";
import IProfile from "../../../models/profile";
import profileService from "../../../services/profile/ProfileService";
import {
    defaultClosingSchedule,
    defaultOpeningSchedule,
} from "../../../models/Schedule";
import CleaningScheduleService from "../../../services/local/CleaningScheduleService";
import LocalFormFields from "../../../pages/table/local/LocalFormFields";
import buildingService from "../../../services/building/BuildingService";
import IBuilding from "../../../models/building";
import FloorService from "../../../services/floor/FloorService";
import IFloor from "../../../models/floor";
import macAddressUtils from "../../../utils/macAddressUtils";
import localService from "../../../services/local/LocalService";
import eslService from "../../../services/esl/EslService";
import IAdminPageBuildingDetail from "../../../models/adminPage/adminPageBuildingDetail";

interface IAddLocalModalProps {
    isShowCreate: boolean;
    setIsShowCreate: (v: boolean) => void;
}
interface IAddLocalModalProps {
    isShowCreate: boolean;
    setIsShowCreate: (v: boolean) => void;
    onRoomCreate?: (id: number) => void;
    floorId: number;
    buildingId: number;
}

const AddLocalModal = ({
    isShowCreate,
    setIsShowCreate,
    onRoomCreate,
    floorId,
    buildingId
}: IAddLocalModalProps) => {
    const closeModal = () => setIsShowCreate(false);
    const { t } = useTranslation();
    const [room, setRoom] = useState(defaultLocalRequest);
    const [buildings, setBuildings] = useState<IAdminPageBuildingDetail[]>([]);
    const [floors, setfloors] = useState<IFloor[]>([]);
    const [profiles, setProfiles] = useState<IProfile[]>([]);
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [isFormSending, setIsFormSending] = useState(false);

    const onCreateRoom = async (event: FormEvent) => {
        event.preventDefault();

        setErrorMessage("");
        setIsFormSending(true);

        if (room.tagMacAddress) {
            const isEslMacValid = await eslService.GetIsValidMac(room.tagMacAddress || "");

            if (!isEslMacValid) {
                setErrorMessage("table.local.macAddressErrorMessage");
                setIsFormSending(false);
                return;
            }
        }


        localService.PostLocal({ ...room, openingSchedule: defaultOpeningSchedule, closingSchedule: defaultClosingSchedule })
            .then((response) => {

                if (response.status === 200) {
                    CleaningScheduleService.PostCleaningSchedule({ ...room.localCleaning, localId: response.data });

                    onRoomCreate && onRoomCreate(response.data)
                    return;
                }
                setErrorMessage("table.local.editErrorMessage");
            })
            .finally(() => setIsFormSending(false));
    };

    useEffect(() => {
        room.buildingId = buildingId;
        room.floorId = floorId;

        setRoom(room);
    }, []);

    useEffect(() => {
        buildingService.GetBuildingById(buildingId).then((b) => setBuildings([b]));
        FloorService.GetFloorById(floorId).then((f) => setfloors([f]));
        profileService.GetProfiles().then((p) => setProfiles(p));
    }, [])


    return (
        <Dialog sx={{
            "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "85vw"
                },
            },
        }}
            open={isShowCreate}
            onClose={closeModal}
        >
            <ModalCard
                sx={{
                    borderRadius: 4,
                    width: 550,
                    height: "100%",
                    overflow: "auto",
                }}
                title={t("local.create")}
                closeCallback={closeModal}
            >
                <ModalCard.Main>
                    {errorMessage && (
                        <Alert
                            severity="error"
                            sx={{ marginBottom: "1em" }}
                        >
                            {t(errorMessage)}
                        </Alert>
                    )}
                    <LocalFormFields
                        localState={room}
                        setLocalState={setRoom}
                        buildings={buildings}
                        buildingFloors={floors}
                        buildingProfiles={profiles}
                        localCleaning={room.localCleaning} />
                </ModalCard.Main>

                <ModalCard.Action>
                    <Progress isLoading={isFormSending}>
                        <Button disabled={
                            !room.name.trim() || !room.buildingId || !room.floorId ||
                            !room.profileId || room.codes.length === 0 || !macAddressUtils.isMacAdrress(room.tagMacAddress ?? "")
                        } onClick={onCreateRoom} variant="contained" color="success">
                            <ModalTitle>{t("table.local.create")}</ModalTitle>
                        </Button>
                    </Progress>
                </ModalCard.Action>

            </ModalCard>
        </Dialog>
    );

}
export default AddLocalModal;
